import { Card } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { NavigationSection } from './sections/NavigationSection';
import { HeroSection } from './sections/HeroSection';
import { ProgramsSection } from './sections/ProgramsSection';
import { StatisticsSection } from './sections/StatisticsSection';
import { ProfileSection } from './sections/ProfileSection';
import { NewsSection } from './sections/NewsSection';
import { ArticlesSection } from './sections/ArticlesSection';
import { PartnersSection } from './sections/PartnersSection';
import { ContactSection } from './sections/ContactSection';
import { SettingsSection } from './sections/SettingsSection';
import { FooterSection } from './sections/FooterSection';
import { VisibilitySection } from './sections/VisibilitySection';

export function WebsiteManagement() {
  return (
    <div className="space-y-6 flex flex-col h-full">
      <Tabs defaultValue="visibility" className="flex flex-col h-full" dir="rtl">
        <div className="overflow-x-auto flex-shrink-0 pb-4">
          <TabsList className="inline-flex flex-wrap w-full h-auto">
            <TabsTrigger value="visibility" className="flex-1 min-w-fit">
              الأقسام
            </TabsTrigger>
            <TabsTrigger value="navigation" className="flex-1 min-w-fit">
              القوائم
            </TabsTrigger>
            <TabsTrigger value="hero" className="flex-1 min-w-fit">
              المطلع
            </TabsTrigger>
            <TabsTrigger value="programs" className="flex-1 min-w-fit">
              البرامج
            </TabsTrigger>
            <TabsTrigger value="statistics" className="flex-1 min-w-fit">
              الإحصائيات
            </TabsTrigger>
            <TabsTrigger value="profile" className="flex-1 min-w-fit">
              نبذة عنا
            </TabsTrigger>
            <TabsTrigger value="news" className="flex-1 min-w-fit">
              الأخبار
            </TabsTrigger>
            <TabsTrigger value="articles" className="flex-1 min-w-fit">
              المقالات
            </TabsTrigger>
            <TabsTrigger value="partners" className="flex-1 min-w-fit">
              الشركاء
            </TabsTrigger>
            <TabsTrigger value="contact" className="flex-1 min-w-fit">
              التواصل
            </TabsTrigger>
            <TabsTrigger value="footer" className="flex-1 min-w-fit">
              التذييل
            </TabsTrigger>
            <TabsTrigger value="settings" className="flex-1 min-w-fit">
              الإعدادات
            </TabsTrigger>
          </TabsList>
        </div>

        <div className="flex-1 overflow-y-auto">
          <TabsContent value="visibility" className="mt-0">
            <VisibilitySection />
          </TabsContent>

          <TabsContent value="navigation" className="mt-0">
            <NavigationSection />
          </TabsContent>

          <TabsContent value="hero" className="mt-0">
            <HeroSection />
          </TabsContent>

          <TabsContent value="programs" className="mt-0">
            <ProgramsSection />
          </TabsContent>

          <TabsContent value="statistics" className="mt-0">
            <StatisticsSection />
          </TabsContent>

          <TabsContent value="profile" className="mt-0">
            <ProfileSection />
          </TabsContent>

          <TabsContent value="news" className="mt-0">
            <NewsSection />
          </TabsContent>

          <TabsContent value="articles" className="mt-0">
            <ArticlesSection />
          </TabsContent>

          <TabsContent value="partners" className="mt-0">
            <PartnersSection />
          </TabsContent>

          <TabsContent value="contact" className="mt-0">
            <ContactSection />
          </TabsContent>

          <TabsContent value="footer" className="mt-0">
            <FooterSection />
          </TabsContent>

          <TabsContent value="settings" className="mt-0">
            <SettingsSection />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}

